import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledTitle = styled.div`
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #191c1e;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 30px;
  font-weight: 500;
  font-size: 13px;
  line-height: 140%;
  letter-spacing: 0.2px;
  color: #191c1e;

  p {
    margin: 16px 0 0;
  }
`

export const StyledButtonGroup = styled.div`
  display: flex;
`

export const StyledButton = styled.button<{
  operateType: 'cancel' | 'confirm'
}>`
  flex: 1;
  background: ${({ operateType }) =>
    operateType === 'confirm' ? '#5f4dbc' : '#ffffff'};
  color: ${({ operateType }) =>
    operateType === 'confirm' ? '#ffffff' : '#604DBC'};
  border: ${({ operateType }) =>
    operateType === 'confirm' ? 'none' : '1px solid #604DBC'};
  border-radius: 48px;
  outline: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  padding: 12px 0;
  width: 100%;
  cursor: pointer;

  ${({ operateType }) =>
    operateType === 'cancel' &&
    css`
      margin-right: 10px;
    `}
`

export const StyledCancelButton = styled.button`
  margin-right: 10px;
`
